// Lets any page open the header's notification panel. The bell owns the panel's
// state, so this just broadcasts a request it listens for.

export type NotificationPanelView = 'list' | 'settings'

export const OPEN_NOTIFICATIONS_EVENT = 'wcid:open-notifications'

export type OpenNotificationsEventDetail = { view: NotificationPanelView }

/** Opens the notification panel, optionally straight to the settings view. */
export const openNotificationsPanel = (view: NotificationPanelView = 'list') => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent<OpenNotificationsEventDetail>(OPEN_NOTIFICATIONS_EVENT, { detail: { view } })
  )
}
